import { apiHorizonFetchEmbedSearchWidget } from 'modules/embedSearchWidget/api/apiFetchEmbedSearchWidget';
import { EmbedSearchWidgetContext } from 'modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import type { embedSearchWidgetRouteGroup } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';
import type { HorizonAppRouteGroupLoaderArgs } from 'routing/classes/types/AppRouteGroupLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetLayoutLoadable } from './EmbedSearchWidgetLayoutLoadable';

export async function loader({
  request,
  context,
  params: { embedSearchWidgetId },
}: HorizonAppRouteGroupLoaderArgs<typeof embedSearchWidgetRouteGroup>) {
  const [embedSearchWidget] = await Promise.all([
    apiHorizonFetchEmbedSearchWidget({ request, context })(embedSearchWidgetId),
    EmbedSearchWidgetLayoutLoadable.load(),
  ]);

  return { embedSearchWidget };
}

export default function EmbedSearchWidgetLayoutHorizonRoute({
  loaderData: { embedSearchWidget },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return (
    <EmbedSearchWidgetContext value={embedSearchWidget}>
      <EmbedSearchWidgetLayoutLoadable />
    </EmbedSearchWidgetContext>
  );
}
